<template>
    <div class="card mt-4 w-100 animated fadeInUp faster">
        <div class="card-header">
            <div class="row align-items-center">
                <div class="col-auto"><i class="fal fa-gift text-primary fa-2x"></i></div>
                <div class="col pl-0"><h5 class="mb-0 font-weight-normal">{{ $t("discounts.header") }}</h5></div>
            </div>
        </div>
        <div class="card-body">
            <div class="row">
                <div class="col-12">
                    <div class="input-group">
                        <input type="text" class="form-control" v-model="code" :placeholder="$t('discounts.form.code_placeholder')">
                        <div class="input-group-append">
                            <button class="input-group-text" @click="applyGiftcard" :disabled="loading">
                                <template v-if="loading">
                                    <i class="fal fa-spin fa-spinner"></i>
                                </template>
                                <template v-else>
                                    {{ $t("discounts.buttons.redeem") }}
                                </template>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Coupon",
        data () {
            return {
                loading: false,
                code: null
            }
        },
        methods: {
            applyGiftcard() {
                if (!this.code) {
                    return this.$swal({ type: 'error', text: this.$t("discounts.messages.missing_code_field") });
                }
                this.loading = true;
                this.$store.dispatch('addGiftCard', this.code)
                    .then(() => this.loading = false)
                    .catch((error) => {
                        if (error.response.status === 404) {
                            this.applyCoupon();
                        } else {
                            this.loading = false;
                            this.$swal({ type: 'error', text: error.response.data.message });
                        }
                    });
            },
            applyCoupon() {
                this.loading = true;
                this.$store.dispatch('addCoupon', this.code)
                    .then(() => this.loading = false)
                    .catch((error) => {
                        this.loading = false;
                        this.$swal({ type: 'error', text: error.response.data.message });
                    });
            }
        }
    }
</script>

<style scoped>

</style>
